import React from 'react'

const Header = () => (
  <header id="header">
    <div className="logo logo-initials" role="img" aria-label="Amrit Thapaliya">
      <span>AT</span>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Amrit Thapaliya</h1>
        <p className="hero-role">
          (Lead SRE / Site Reliability / Platform &amp; .NET) Engineer
        </p>
        <p className="hero-bio">
          Lead SRE at UBA Solutions. Based in <strong>Bhaktapur, Nepal</strong>.
          Building reliable systems, and engineering practices
          across logistics, travel, ecommerce, and enterprise software products.
        </p>
      </div>
    </div>
    <nav aria-label="Primary">
      <ul>
        <li>
          <a className="nav-anchor" href="#expertise">
            Expertise
          </a>
        </li>
        <li>
          <a className="nav-anchor" href="#services">
            Services
          </a>
        </li>
        <li>
          <a className="nav-anchor" href="#contact">
            Contact
          </a>
        </li>
      </ul>
    </nav>
  </header>
)

export default Header
